import { axios } from "../../config/axios";

export const audiencesAPI = {

  /**
   * Get all audiences for the current merchant
   * @returns {object}
   * @param params
   */
  fetchAudiences(params) {
    return axios.get(`/api/v3/audiences`, {params}).then(res => res.data);
  },

  /**
   * Get all audiences incompleted
   * @returns {object}
   */
  fetchAudiencesIncomplete() {
    return axios.get(`/api/v3/audiences/incomplete`).then(res => res.data);
  },

  /**
   * Get an audience
   * @param {number, string} audienceId
   * @returns {object}
   */
  fetchAudience(audienceId) {
    return axios.get(`/api/v3/audiences/${audienceId}/edit`).then(res => res.data);
  },

  /**
   * Get the audiences options
   * @returns {object}
   */
  fetchOptions() {
    return axios.get(`/api/v3/audiences/options`).then(res => res.data);
  },


  /**
   * Get KPI data
   * @param {object} data
   * @returns {object}
   */
  fetchEstimatedKpiData(data) {
    return axios.post(`/api/v3/audiences/estimated_kpi_data/`, data).then(res => res.data);
  },

  /**
   * Get a kpi for a given audience
   * @param {number} audienceId
   * @param {string} kpiName
   * @param {{
   *  period: String
   *  sort_key: String
   *  attr_key: String
   * }} params
   * @returns {object}
   */
  fetchAudienceKpi(audienceId, kpiName, params) {
    return axios.get(`/api/v3/audiences/${audienceId}/kpi_data/${kpiName}`, {params}).then(res => res.data);
  },

  /**
   * Get the values for a given filter
   * @param {string} filterName
   * @returns {object}
   */
  fetchFilterValues(filterName) {
    return axios.get(`/api/v3/filters/${filterName}`).then(res => res.data);
  },

  /**
   * Create an audience
   * @param {object} data
   * @returns {object}
   */
  createAudience(data) {
    return axios.post(`/api/v3/audiences/`, data).then(res => res.data);
  },

  /**
   * Update an audience
   * @param {number} audienceId
   * @param {object} data
   * @returns {object}
   */
  updateAudience(audienceId, data) {
    return axios.patch(`/api/v3/audiences/${audienceId}`, data).then(res => res.data);
  },

  /**
   * Delete an audience
   * @param {number} audienceId
   */
  deleteAudience(audienceId) {
    return axios.delete(`/api/v3/audiences/${audienceId}`).then(res => res.data);
  },

  /**
   * Refresh an audience
   * @param {string} audienceId
   */
  refreshAudience(audienceId) {
    return axios.post(`/api/v3/audiences/${audienceId}/refresh`).then(res => res.data);
  },

  /**
   * Get event options for bonus engine
   * @param {string} data_url
   * @param {{ page: number, per_page: number, search: string }} params
   * @returns {array} Array of options available for an event
   */
  fetchEventValues(data_url, params = {}) {
    if (!params.per_page) params.per_page = 12;
    return axios.get(data_url, {params})
                .then(res => res.data);
  }

};
